import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Paper,
  Stack,
  Collapse,
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { Link } from "react-router-dom";

import SportsMartialArtsIcon from "@mui/icons-material/SportsMartialArts";
import KeyIcon from "@mui/icons-material/Key";
import {
  createRegistration
} from "../services/registrationService";

export default function Registration() {
  const navigate = useNavigate();

  const [mode, setMode] = useState<"new" | "existing" | null>(null);

  const [accepted, setAccepted] = useState(false);
  const [registrationCode, setRegistrationCode] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [generatedCode, setGeneratedCode] = useState("");

  const [invalidCode, setInvalidCode] = useState(false);

  const isLocal = window.location.hostname === "localhost";
  const API_URL = isLocal ? "http://localhost:7881/api" // backend local sans /api 
    : "/api"; // backend prod avec /api

  const generateCode = async () => {
    const registration =
      await createRegistration();

    // console.log(
    //   "Code généré :",
    //   registration.registrationCode
    // );

    localStorage.setItem(
      "registrationCode",
      registration.registrationCode
    );

    // console.log(
    //   "Code enregistré :",
    //   localStorage.getItem("registrationCode")
    // );

    setGeneratedCode(
      registration.registrationCode
    );

    setRegistrationCode(
      registration.registrationCode
    );

    setDialogOpen(true);
  };

  const checkRegistrationCode = async () => {
    const registrationCode =
      localStorage.getItem("registrationCode");

    // console.log(
    //   "Code trouvé dans le localStorage :",
    //   registrationCode
    // );

    if (!registrationCode) {
      // console.log("Aucun code trouvé");
      return;
    }

    try {
      // console.log(
      //   "Appel API :",
      //   `http://localhost:7881/api/registration/${registrationCode}`
      // );

      const response = await fetch(
        `${API_URL}/registration/${registrationCode}`
      );

      // console.log(
      //   "Status de retour :",
      //   response.status
      // );

      if (!response.ok) {
        console.error(
          "Code invalide détecté :",
          registrationCode
        );

        setInvalidCode(true);

        // localStorage.removeItem(
        //   "registrationCode"
        // );

        return;
      }

      // console.log(
      //   "Code valide détecté :",
      //   registrationCode
      // );

      setMode("existing");
      setRegistrationCode(registrationCode);

    } catch (error) {

      console.error(
        "Erreur lors de la vérification du code :",
        error
      );

      setInvalidCode(true);

      // localStorage.removeItem(
      //   "registrationCode"
      // );
    }
  };

  // useEffect(() => {
  //   console.log("LocalStorage complet :", {
  //     registrationCode:
  //       localStorage.getItem("registrationCode"),
  //   });
  // }, []);

  useEffect(() => {
    checkRegistrationCode();
  }, []);

  // useEffect(() => {
  //   console.log(
  //     "invalidCode a changé :",
  //     invalidCode
  //   );
  // }, [invalidCode]);

  // useEffect(() => {
  //   console.log("Mode actuel :", mode);
  // }, [mode]);

  const goToManageRegistration = () => {

    // console.log(
    //   "AVANT :",
    //   localStorage.getItem("registrationCode")
    // );

    // console.log(
    //   "STATE :",
    //   registrationCode
    // );

    localStorage.setItem(
      "registrationCode",
      registrationCode
    );

    // console.log(
    //   "APRES :",
    //   localStorage.getItem("registrationCode")
    // );

    navigate("/manage-registration");
  };

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        px: 3,
        py: 4,
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
      >
        Gérer mes inscriptions
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4 }}
      >
        Open International de Sambreville
      </Typography>

      {/* <Typography
        sx={{
          mb: 2,
          color: "orange",
        }}
      >
        Code actuel :
        {" "}
        {localStorage.getItem("registrationCode") ?? "<aucun>"}
      </Typography> */}

      <Stack spacing={2}>
        <Paper
          elevation={mode === "new" ? 4 : 2}
          onClick={() => setMode("new")}
          sx={{
            p: 3,
            cursor: "pointer",
            border:
              mode === "new"
                ? "2px solid #d50000"
                : "2px solid transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            <SportsMartialArtsIcon
              color="primary"
              fontSize="large"
            />

            <Box>
              <Typography variant="h6">
                Première inscription
              </Typography>

              <Typography color="text.secondary">
                C'est la première fois que j'inscris un judoka
                à ce tournoi.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Collapse in={mode === "new"}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              mb: 2,
              backgroundColor: "background.default",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
            >
              Première inscription
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={accepted}
                  onChange={(e) =>
                    setAccepted(e.target.checked)
                  }
                />
              }
              label="J'accepte que mes données soient utilisées et stockées dans le cadre exclusif de l'Open International de Sambreville."
            />

            <Button
              variant="contained"
              color="error"
              disabled={!accepted}
              sx={{ mt: 2 }}
              onClick={generateCode}
            >
              Générer mon code d'inscription
            </Button>
          </Paper>
        </Collapse>

        <Paper
          elevation={mode === "existing" ? 4 : 2}
          onClick={() => setMode("existing")}
          sx={{
            p: 3,
            cursor: "pointer",
            border:
              mode === "existing"
                ? "2px solid #d50000"
                : "2px solid transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            <KeyIcon
              color="primary"
              fontSize="large"
            />

            <Box>
              <Typography variant="h6">
                J'ai déjà un code
              </Typography>

              <Typography color="text.secondary">
                Consulter ou modifier mes inscriptions.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Collapse in={mode === "existing"}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              backgroundColor: "background.default",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
            >
              Merci de fournir votre code d'inscription
            </Typography>

            <TextField
              fullWidth
              label="Code d'inscription"
              value={registrationCode}
              onChange={(e) =>
                setRegistrationCode(e.target.value)
              }
              sx={{ mb: 3 }}
            />

            <Button
              variant="contained"
              color="error"
              disabled={!registrationCode.trim()}
              onClick={goToManageRegistration}
            >
              Gérer mes inscriptions
            </Button>
          </Paper>
        </Collapse>
      </Stack>
      {/* 
      <Typography color="warning.main">
        localStorage :
        {" "}
        {localStorage.getItem("registrationCode")}
      </Typography>

      <Typography color="success.main">
        State :
        {" "}
        {registrationCode}
      </Typography> */}

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Votre code d'inscription
        </DialogTitle>

        <DialogContent>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              mb: 3,
            }}
          >
            {generatedCode}
          </Typography>

          <Typography>
            Conservez précieusement ce code.
          </Typography>

          <Typography sx={{ mt: 2 }}>
            Il vous permettra de gérer vos inscriptions
            ultérieurement.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={() =>
              navigator.clipboard.writeText(generatedCode)
            }
          >
            Copier le code
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={goToManageRegistration}
          >
            Gérer mes inscriptions
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={invalidCode}
        onClose={() => setInvalidCode(false)}
      >
        <DialogTitle>
          Code d'inscription invalide
        </DialogTitle>

        <DialogContent>
          <Typography>
            Le code d'inscription sauvegardé sur cet appareil
            n'est plus valide.
          </Typography>

          <Typography sx={{ mt: 2 }}>
            Vous pouvez générer un nouveau code d'inscription
            ou contacter l'organisation si vous pensez qu'il
            s'agit d'une erreur.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            component={Link}
            to="/contact"
          >
            Nous contacter
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setInvalidCode(false);
              setMode("new");
            }}
          >
            Générer un nouveau code
          </Button>

          {/* <Button
            variant="contained"
            color="error"
            onClick={() => setInvalidCode(false)}
          >
            Générer un nouveau code
          </Button> */}
        </DialogActions>
      </Dialog>
    </Box>
  );
}